import { createSlice } from "@reduxjs/toolkit";
import { add } from "date-fns";
import authApi from "./authApi";
import { WolAuthInfo } from "../../app/types";

export interface AuthState {
  access_token: string | null;
  expires_at: string | null;
  refresh_token: string | null;
  is_override: boolean;
}

const initialState: AuthState = {
  access_token: null,
  expires_at: null,
  refresh_token: null,
  is_override: false,
};

const authReducer = (
  state: AuthState,
  { payload }: { payload: WolAuthInfo },
) => {
  const { access_token, refresh_token, expires_in } = payload;
  return {
    access_token,
    refresh_token,
    expires_at: add(Date.now(), { seconds: expires_in }).toISOString(),
    is_override: false,
  };
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      authApi.endpoints.getInitialAuth.matchFulfilled,
      authReducer,
    );
    builder.addMatcher(
      authApi.endpoints.getRefreshTokenAuth.matchFulfilled,
      authReducer,
    );
  },
});

export default authSlice;
